export class ListaPresenca {
    constructor({
      id = null,
      formacao = null,
      dataRealizacao = null,
      cargaHoraria = null,
      localRealizacao = null,
      listaInstrutores = Array(),
      participantes = Array(),
      bloquearCampos = false
    }) {
        this.id = id;
        this.formacao = formacao;
        this.dataRealizacao = dataRealizacao;
        this.cargaHoraria = cargaHoraria;
        this.localRealizacao = localRealizacao;
        this.listaInstrutores = listaInstrutores;
        this.participantes = participantes;
        this.bloquearCampos = bloquearCampos;
    }
    static Build() {
      return new ListaPresenca({
        id: null,
        formacao: null,
        dataRealizacao: null,
        cargaHoraria: null,
        localRealizacao: null,
        listaInstrutores: Array(),
        participantes: Array(),
        bloquearCampos: false
      });
    }
    format() {
      return {
        id: this.id,
        formacao: this.formacao,
        dataRealizacao: this.dataRealizacao,
        cargaHoraria: this.cargaHoraria,
        localRealizacao: this.localRealizacao,
        listaInstrutores: this.listaInstrutores,
        participantes: this.participantes,
        bloquearCampos: this.bloquearCampos
      };
    }
  }
  